export default __webpack_public_path__ + "static/media/search.dfd6d58b.svg";